module.exports = __webpack_public_path__ + "img/logo.1d71e8b6.png";